var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.265,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SmartX",
    transform: "translate(-255 -274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6106",
    "data-name": "Rectangle 6106",
    width: 24,
    height: 24,
    transform: "translate(255 274)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smartx-2",
    "data-name": "smartx",
    transform: "translate(255 277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7997",
    "data-name": "Group 7997",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15534",
    "data-name": "Path 15534",
    d: "M8.723,16.859c0,.085-.085.169-.085.254V17.2c0,.085-.085.085-.085.169v.085a.182.182,0,0,1-.169.169h0L8.3,17.7h.169a1.349,1.349,0,0,0,1.183-.676,1.3,1.3,0,0,0,0-1.352A1.349,1.349,0,0,0,8.469,15H8.3l.085.085v.085c.085.085.085.085.085.169v.085c0,.085.085.085.085.169v.085h0c0,.085.085.169.085.254h0v.845h0c.169-.169.085-.085.085.084Z",
    transform: "translate(-2.554 -6.972)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M1.437,13.944A1.22,1.22,0,0,1,.425,13.52,1.386,1.386,0,0,1,0,12.507V5.662H21.972v6.845a1.554,1.554,0,0,1-.425,1.014,1.388,1.388,0,0,1-1.014.424Zm4.478-2.537a1.765,1.765,0,0,0,1.691-1.1,2.331,2.331,0,0,0,0-2.112A2.059,2.059,0,0,0,5.832,7.185a1.513,1.513,0,0,0-.845.169,2.475,2.475,0,0,0-.848-.169,2.059,2.059,0,0,0-1.432.676A2.021,2.021,0,0,0,2.113,9.3a1.84,1.84,0,0,0,.675,1.52,2.207,2.207,0,0,0,1.437.589,1.526,1.526,0,0,0,.845-.169A2.458,2.458,0,0,0,5.915,11.407ZM10.4,10.142a.362.362,0,0,0,.337.339h8.874a.338.338,0,0,0,0-.676H10.733A.308.308,0,0,0,10.4,10.142Zm0-1.691a.362.362,0,0,0,.337.337h8.874a.338.338,0,0,0,0-.676H10.733A.308.308,0,0,0,10.4,8.45ZM0,2.787V1.436A1.39,1.39,0,0,1,.425.423,1.226,1.226,0,0,1,1.437,0H20.621a1.55,1.55,0,0,1,1.012.423,1.394,1.394,0,0,1,.422,1.013V2.787Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    "data-name": "Rectangle 1690",
    width: 22.056,
    height: 2.113,
    transform: "translate(0 3.127)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537",
    "data-name": "Path 15537",
    d: "M6.137,17.689a1.592,1.592,0,0,0,.676-.169,1.319,1.319,0,0,0,.676-1.1v-.169a1.592,1.592,0,0,0-.169-.676.986.986,0,0,0-.507-.507,1.592,1.592,0,0,0-.676-.169,1.756,1.756,0,0,0-1.014.423A1.4,1.4,0,0,0,4.7,16.337a1.559,1.559,0,0,0,.423,1.014A2.4,2.4,0,0,0,6.137,17.689Z",
    transform: "translate(-1.996 -6.956)",
    fill: "#18253e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15538",
    "data-name": "Path 15538",
    d: "M23.548,16.4h-.507a4.663,4.663,0,0,0,.507,9.3A4.522,4.522,0,0,0,27.6,23.33a4.094,4.094,0,0,0,.592-2.2A4.763,4.763,0,0,0,23.548,16.4Z",
    transform: "translate(-4.196 -7.189)",
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15539",
    "data-name": "Path 15539",
    d: "M24.535,20.328h-2.2c-.254,0-.338-.085-.338-.254a.31.31,0,0,1,.338-.338h2.2c0-.085-.085-.169-.085-.254a1.192,1.192,0,0,0-1.014-.676h-1.1c0,.085-.169,0-.169-.085-.169-.169,0-.423.254-.423h3.211c.169,0,.338.085.338.254a.31.31,0,0,1-.338.338h-.845a6.131,6.131,0,0,0,.423.761h.423c.254,0,.338.085.338.338,0,.169-.169.254-.338.254h-.423A1.778,1.778,0,0,1,23.183,21.6c.085.085.085.169.169.169.592.592,1.1,1.1,1.775,1.69l.169.169a.384.384,0,0,1,0,.423.377.377,0,0,1-.423,0,.083.083,0,0,1-.085-.085c-.761-.676-1.521-1.521-2.282-2.2-.338-.169-.507-.254-.423-.423s.254-.169.423-.169h1.014A.892.892,0,0,0,24.535,20.328Z",
    transform: "translate(-4.676 -7.483)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartx);
export default __webpack_public_path__ + "static/media/smartx.bca5e45ab3887fb403e99d181fdaf0bc.svg";
export { ForwardRef as ReactComponent };